import { render, staticRenderFns } from "./MemberBasicDetails.vue?vue&type=template&id=47bdd4e7&scoped=true"
import script from "./MemberBasicDetails.vue?vue&type=script&lang=js"
export * from "./MemberBasicDetails.vue?vue&type=script&lang=js"
import style0 from "./MemberBasicDetails.vue?vue&type=style&index=0&id=47bdd4e7&prod&lang=css"
import style1 from "./MemberBasicDetails.vue?vue&type=style&index=1&id=47bdd4e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bdd4e7",
  null
  
)

export default component.exports